export default __webpack_public_path__ + "static/media/empty-tasks.7ebf7268.svg";